var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:['title', _vm.textAlignCenter ? 'text_align_center' : 'text_align_center_mobile'],style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }